import React from 'react';
import { Grid, Menu } from 'semantic-ui-react';
import { NavLink, Outlet, useLocation, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import './index.scss';

const CampaignSessionSummary = () => {
    const { id } = useParams();

    const outreachTypes = useSelector((state) => (state.campaigns.campaign?.is_company_campaign?.campaign_type || [])?.slice(0).sort());
    const campaign = useSelector((state) => state.campaigns.campaign);

    const hasOutreachType = (type) => {
        return outreachTypes?.includes(type);
    }

    const { pathname } = useLocation();
    const tab = pathname.split("/")[4];
    const isOnlyDialerCampaign = campaign?.is_company_campaign?.campaign_type === null || !campaign?.is_company_campaign?.campaign_type?.includes("text");

    return (
        <Grid>
            <Grid.Row>
                <Grid.Column>
                    <Menu size='small' compact stackable className='CampaignSessionSummary__tabMenu'>
                        {(hasOutreachType("dialer") || isOnlyDialerCampaign) && (
                            <Menu.Item as={NavLink} name='Dialer' to={`/campaigns/${id}/session-summary/dialer`} />
                        )}
                        {hasOutreachType("text") && (
                            <Menu.Item as={NavLink} name='Text' to={`/campaigns/${id}/session-summary/text`} />
                        )}
                    </Menu>
                </Grid.Column>
            </Grid.Row>
            {hasOutreachType(tab) && (
                <Grid.Row>
                    <Grid.Column>
                        <Outlet />
                    </Grid.Column>
                </Grid.Row>
            )}
        </Grid>
    );
};
export default CampaignSessionSummary;

